import React from 'react';
import { motion } from 'framer-motion';
import { 
  Cloud, 
  Zap, 
  ShoppingCart, 
  Briefcase, 
  Users, 
  Mail, 
  WandSparkles, 
  Database, 
  Gem, 
  BarChart3,
  Slack,
  Blocks
} from 'lucide-react';
import FloatingIcons from './FloatingIcons';

interface Technology {
  name: string;
  icon: React.ComponentType<{ size: number; style?: React.CSSProperties }>;
  color: string;
}

function About() {
  const technologies: Technology[] = [
    { name: "Salesforce", icon: Cloud, color: '#00a1e0' },
    { name: "Lightning & LWC", icon: Zap, color: '#0176d3' },
    { name: "Sales Cloud", icon: ShoppingCart, color: '#00a1e0' },
    { name: "Service Cloud", icon: Briefcase, color: '#0176d3' },
    { name: "Experience Cloud", icon: Users, color: '#0176d3' },
    { name: "Marketing Cloud", icon: Mail, color: '#00a1e0' },
    { name: "Agentforce", icon: WandSparkles, color: '#0176d3' },
    { name: "Slack", icon: Slack, color: '#4a154b' },
    { name: "Data Migration", icon: Database, color: '#0176d3' },
    { name: "Integration", icon: Blocks, color: '#00a1e0' },
    { name: "RubyOnRails", icon: Gem, color: '#cc0000' },
    { name: "Tableau", icon: BarChart3, color: '#e97627' }
  ];

  return (
    <section className="about-section white-wave" id="about">
      <FloatingIcons />
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h3 className="section-title">About Me</h3>
            <blockquote className="quote">
              "Programming is not only my Profession, It's my ultimate Passion"
            </blockquote>
            <div className="about-description">
              <p>
                I spent over a decade in various software development and gained a handful of experience. 
                Since Sept 2011, I have been working on Salesforce.com. Comfortable in Solution Design, 
                Development, Customisation and Configuration.
              </p>
              <p>
                I have extensive experience implementing Customer and Partner Communities, Lightning Components, 
                and LWC. I am also an expert in Robust, Configurable, Dynamic, and scalable solutions.
              </p>
              <p>
                I also have vast experience in Data Migration and Integration using third-party ETL tools 
                like SnapLogic, IBM WebSphere Cast Iron, Talend, JitterBit, DBAmp, and Salesforce Data Loader.
              </p>
            </div>
          </div>
          <div className="skills-section">
            <h4>Core Technologies</h4>
            <div className="skills-grid">
              {technologies.map((tech, index) => {
                const Icon = tech.icon;
                return (
                  <motion.div 
                    key={index} 
                    className="skill-item"
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.3, delay: index * 0.05 }}
                    whileHover={{ scale: 1.1, rotate: 2 }}
                  >
                    <Icon size={20} style={{ color: tech.color, marginRight: '8px' }} />
                    <span>{tech.name}</span>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;

